
/**
 * CloudFront 경로를 S3 경로로 변환하는 함수
 *
 * @param filePath API에서 내려온 CloudFront file_path
 * @returns 변환된 S3 URL
 */

export function convertToS3Url(filePath) {
  if (!filePath) return "";

  return filePath.replace(
    "https://d2pmkd4do0d0hl.cloudfront.net",
    process.env.REACT_APP_S3_URL
  );
}


/**
 * CloudFront URL을 R2 URL로 변환하고 /media 제거
 * @param url 기존 CloudFront URL
 * @returns 변환된 R2 URL
 */
export function convertToR2Url(url) {
  const cloudfrontDomain = "https://d2pmkd4do0d0hl.cloudfront.net/media";
  const r2Domain = process.env.REACT_APP_R2_URL

  return url.replace(cloudfrontDomain, r2Domain);
}